<template>
    <div class="col-md-12">
        <div class="row border settings-table">
            <div class="col-md-4">
                <dl class="settings-table-item">
                    <dt class="settings-table-item__title">{{'dro.target_behaviour' | trans}}:</dt>
                    <dd class="settings-table-item__subtitle">{{settings.aimTypeId | aimType}}</dd>
                </dl>
            </div>
            <!--<div class="col-md-3">
                <dl class="settings-table-item">
                    <dt class="settings-table-item__title">{{'dro.behaviour_type' | trans}}:</dt>
                    <dd class="settings-table-item__subtitle">{{settings.behaviourTypeId | behaviourType}}</dd>
                </dl>
            </div>-->
            <div class="col-md-4">
                <dl class="settings-table-item">
                    <dt class="settings-table-item__title">{{'dro.list.time' | trans}}:</dt>
                    <dd class="settings-table-item__subtitle">{{intervalDuration | minutes}}</dd>
                </dl>
            </div>
            <div class="col-md-4">
                <dl class="settings-table-item">
                    <dt class="settings-table-item__title">{{'dro.behaviour_description' | trans}}:</dt>
                    <dd class="settings-table-item__subtitle">{{settings.behaviourDescription}}</dd>
                </dl>
            </div>
        </div>
    </div>
</template>

<script>
  import {mapGetters, mapState} from 'vuex';

  export default {
    computed: {
      ...mapState('dro/session', [
        'settings',
      ]),
      ...mapGetters('dro/session', [
        'intervalDuration',
      ]),
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/SettingsTable.vue